import React from 'react';
import './Card.css';

interface CardProps {
	children: React.ReactNode;
	variant?: 'default' | 'elevated' | 'outlined' | 'green-outlined';
	className?: string;
	hoverable?: boolean;
	onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
	children,
	variant = 'default',
	className = '',
	hoverable = true,
	onClick,
}) => {
	return (
		<div
			className={`goat-card goat-card--${variant} ${hoverable ? 'goat-card--hoverable' : ''} ${onClick ? 'goat-card--clickable' : ''} ${className}`.trim()}
			onClick={onClick}
			role={onClick ? 'button' : undefined}
			tabIndex={onClick ? 0 : undefined}
			onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') onClick(); } : undefined}
		>
			{children}
		</div>
	);
};

export default Card;
